import { Container, Col, Row, Form, Button } from 'react-bootstrap';

import { pageKey } from '@/routes';
import { useItemCatalogueController } from '@/controller/useItemCatalogueCtlr';

import Navbar from '../components/Navbar';
import TableSwitcher from '../components/TableSwitcher';
import {
  ItemCatalogueTable,
  SystemPropertiesTable,
} from '../components/Tables';
import {
  ItemCatalogueAddModal,
  PropertiesAddModal,
} from '../components/Modals';

/**
 * Item Catalogue Management:
 *
 * - table1: ItemCatalogueTable
 * - table2: SystemPropertiesTable
 *
 * @data 2025/03/21
 *
 * @returns
 */
const ItemCataloguePage = () => {
  const {
    activeTab,
    filter,
    itemsAfterFilter,
    activeCompanies,
    isModalOpen,
    propertiesQuery,
    ...ctlr
  } = useItemCatalogueController();
  return (
    <>
      <Container>
        <Row>
          {/* left sidebar navigation */}
          <Col className="bg-dark sidebar d-flex flex-column">
            <Navbar activePage={pageKey.CATALOGUE} />
          </Col>
          {/* === MAIN CONTENT OF ITEM MANAGEMENT === */}
          <Col className="ms-8">
            <div
              className=" d-flex flex-column mt-4"
              style={{ minHeight: '100vh' }}
            >
              {/* == title & tabs */}
              {/* use fixed width to stabalize title & tabs - @2025/03/20 */}
              <div className="header w-100">
                <h3 className="text-center text-decoration-underline">
                  Item Catalogue Managment
                </h3>
                <div className="d-flex gap-6 mt-6 justify-content-between">
                  <TableSwitcher
                    activeTab={activeTab}
                    setActiveTab={ctlr.setActiveTab}
                  />
                  {activeTab === 'table1' && (
                    <div className="mb-2 fmw-300 d-flex justify-content-between">
                      <button
                        className="btn btn-success btn-lg me-2"
                        onClick={() => ctlr.setIsModalOpen(true)}
                      >
                        Add Item
                      </button>
                      <select
                        aria-label="toggle custom"
                        name="toggle-type"
                        className="form-select w-50 border border-primary"
                        value={filter}
                        onChange={ctlr.handlSelectChange}
                      >
                        <option value="ALL">ALL</option>
                        <option value="CUSTOM">CUSTOM</option>
                        <option value="STANDARD">STANDARD</option>
                      </select>
                    </div>
                  )}
                  {activeTab === 'table2' && (
                    <button
                      className="btn btn-success btn-lg mt-1"
                      style={{ height: '75%' }}
                      onClick={() => ctlr.setIsModalOpen(true)}
                    >
                      Add Property
                    </button>
                  )}
                </div>
              </div>
              {/* == catalogue table | propertis table == */}
              {/* FIXME: change width from `w-75` to `w-100` @2025/04/23 */}
              <div className="w-100 mw-100 mt-4 mb-4 bg-white">
                {activeTab === 'table1' && (
                  <ItemCatalogueTable
                    data={itemsAfterFilter}
                    properties={propertiesQuery.data}
                    activeCompanies={activeCompanies || []}
                  />
                )}
                {activeTab === 'table2' && (
                  <SystemPropertiesTable properties={propertiesQuery.data} />
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      {activeTab === 'table1' && (
        <ItemCatalogueAddModal
          show={isModalOpen}
          activeCompanies={activeCompanies || []}
          handleClose={() => ctlr.setIsModalOpen(false)}
        />
      )}
      {activeTab === 'table2' && (
        <PropertiesAddModal
          show={isModalOpen}
          handleClose={() => ctlr.setIsModalOpen(false)}
        />
      )}
    </>
  );
};

export default ItemCataloguePage;
